import { Button } from "@simplybusiness/mobius";
import { DatePicker } from "@simplybusiness/mobius-datepicker";
import { useState } from "react";
import type { QuestionComponentProps } from "../../types";
import { getFutureDate, getTodayDate, getTomorrowDate } from "./utils";
import "./DateQuestion.css";

export const DateQuestion = ({
  questionFieldProps,
  config,
}: QuestionComponentProps) => {
  const {
    value,
    onChange,
    isRequired,
    questionLabelProps,
    helpInfo,
    ...otherProps
  } = questionFieldProps;
  const { minDays, maxDays, futureOnly } = config ?? {};
  const [localValue, setLocalValue] = useState(value as string);

  // TODO: Rationalise this with the DateInputQuestion
  // We need to support range validation as well as dateRange

  let minDate = undefined;

  if (futureOnly) {
    minDate = getTodayDate();
  }
  if (minDays !== undefined) {
    minDate = getFutureDate(Number(minDays));
  }

  const handleChange = (date = "") => {
    setLocalValue(date);
    onChange!({
      target: { name: questionFieldProps.name, value: date },
    });
  };

  return (
    <div className="mobius-question__date-question">
      <div className="mobius-question__date-question-actions">
        <Button
          size="md"
          type="button"
          variant="secondary"
          onClick={() => handleChange(getTodayDate())}
        >
          Today
        </Button>
        <Button
          size="md"
          type="button"
          variant="secondary"
          onClick={() => handleChange(getTomorrowDate())}
        >
          Tomorrow
        </Button>
      </div>
      <DatePicker
        onChange={handleChange}
        defaultValue={localValue}
        min={minDate}
        max={maxDays ? getFutureDate(maxDays as number) : undefined}
        {...otherProps}
      />
    </div>
  );
};
